<div class="banner d-flex flex-wrap align-items-center" [ngClass]="'banner-'+ type">
  <div
    class="banner_overlay"
    [style.background-image]="'url(' + image + ')'"
    *ngIf="image"></div>
  <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
    <div class="row">
      <div class="col-12">
        <h1 class="banner_title" *ngIf="hasTitle">{{title}}</h1>
        <h2 class="banner_subtitle" *ngIf="hasSubTitle">
          {{subTitle}}
        </h2>
        <a class="btn btn-default banner_button" (click)="onButtonClick()" *ngIf="hasButton">
          <span>
              {{buttonText}}
          </span>
          <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
</div>
